import React, { useState, useCallback } from 'react';
import { useRetryableObservable } from 'react-use-observable';

import type { ShoppingDelivery } from 'v2/interfaces/shopping';
import shoppingService from 'v2/services/shopping/product';

import ProductList from './List';
import ProductQuickview from './Quickview';

const Product = () => {
  const [currentDelivery, setCurrentDelivery] = useState(null);
  const [open, setOpen] = useState<boolean>(false);

  const [, , , loadAgain] = useRetryableObservable(() => shoppingService.loadDeliveries(), []);

  const openQuickView = useCallback((shopping: ShoppingDelivery) => {
    setCurrentDelivery(shopping);
    setOpen(true);
  }, []);

  const closeQuickView = useCallback(
    (refetch?: boolean) => {
      setOpen(false);
      setCurrentDelivery(null);

      if (refetch) {
        loadAgain();
      }
    },
    [loadAgain]
  );

  return (
    <div id={'shopping-product'} className='w-full'>
      <ProductList onClickRow={openQuickView} handleReloadProducts={loadAgain} />
      <ProductQuickview
        open={open}
        onClose={closeQuickView}
        delivery={currentDelivery}
        closeQuickView={closeQuickView}
      />
    </div>
  );
};

export default Product;
